module.exports = __webpack_public_path__ + "static/media/Tine_Gasta.17a8ad88.png";